import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import { Notify } from '@flexisaf/flexibull2';
import urls from 'utils/config';
import {
  sendSmsToApplicantsFailed,
  sendSmsToApplicantsSuccess,
} from 'redux/applicants/actions';
import ApplicantsActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

const isUuid = (value) =>
  typeof value === 'string' &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    value
  );

function* sendSms({ payload: { data, cb } }) {
  const { candidateIds, message, applicationId, stageId, status } = data;
  const url = `${API_BASE_URL}/sms/candidates`;

  const submissionData = {
    message,
    applicationId,
  };

  if (isUuid(stageId)) {
    submissionData.stageId = stageId;
  }
  if (status) {
    submissionData.status = status;
  }
  if (candidateIds?.length > 0) {
    submissionData.candidateIds = candidateIds;
  }

  const response = yield request({
    method: 'post',
    data: submissionData,
    url,
  });

  if (response.success) {
    Notify('SMS sent successfully', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    if (cb) cb();
    yield put(sendSmsToApplicantsSuccess());
  } else {
    networkErrorHandler(response?.statusCode, response?.message);
    yield put(sendSmsToApplicantsFailed(response.message));
  }
}

export function* onSmsSend() {
  yield takeEvery(ApplicantsActionTypes.SEND_SMS_START, sendSms);
}
